export default __webpack_public_path__ + "static/media/drop-shadow-topbar-night.d9cd7d05.webp";